
import Vue from 'vue';

export default Vue.extend({
  name: 'AboutUsBackground',
  mounted() {
    this.parallaxListenerInit();
  },
  methods: {
    parallaxListenerInit() {
      if (!this.$refs.backgroundWrapper) return;

      // this.$refs.backgroundWrapper.addEventListener('mousemove', e => {
      //   if (
      //     !this.$refs.backgroundBubble1 ||
      //     !this.$refs.backgroundBubble2 ||
      //     !this.$refs.backgroundBubble3 ||
      //     !this.$refs.backgroundBubble4
      //   )
      //     return;
      //
      //   const pageX = e?.clientX - window.innerWidth / 2;
      //   const pageY = e?.clientY - window.innerHeight / 2;
      //
      //   this.$refs.backgroundBubble1.style.transform =
      //     'translateX(-' + (50 + pageX / 22) + '%) translateY(-' + (50 + pageY / 22) + '%)';
      //   this.$refs.backgroundBubble2.style.transform =
      //     'translateX(-' + (50 + pageX / 33) + '%) translateY(-' + (50 + pageY / 33) + '%)';
      //   this.$refs.backgroundBubble3.style.transform =
      //     'translateX(-' + (50 + pageX / 33) + '%) translateY(-' + (50 + pageY / 33) + '%)';
      //   this.$refs.backgroundBubble4.style.transform =
      //     'translateX(-' + (50 + pageX / 22) + '%) translateY(-' + (50 + pageY / 22) + '%)';
      // });
    },
  },
});
